import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import * as Sentry from '@sentry/react';

// Initialize Sentry with both replay and profiling integrations
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: false,
      maskAllText: false,
      captureBody: true,
      minReplayDuration: 0,
    }),
    // Add browser tracing integration
    Sentry.browserTracingIntegration(),
  ],
  
  // Session replay settings
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  
  // Tracing settings
  tracesSampleRate: 1.0,
});

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);